/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type WorkState = (typeof WorkState)[keyof typeof WorkState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkState = {
  active: 'active',
  stalled: 'stalled',
  waiting: 'waiting',
  submitted: 'submitted',
  completed: 'completed',
} as const;
